const DaNestareV2 = () => import("./DaNestareV2");
const Programmi = () => import("./Programmi");
const InTaglio = () => import("./InTaglio");
const OseonJobs = () => import("./OseonJobs");
const OseonJobsV2 = () => import("./OseonJobsV2");
const OseonMaterialWithdrawals = () => import("./OseonMaterialWithdrawals.vue");
const NestingDetail = () => import("./NestingDetail.vue");
const OseonControlRoom = () => import("./OseonControlRoom");
const OseonUnstrippedProblems = () => import("./OseonUnstrippedProblems");
const OseonHeadCollisionAnalysis = () => import("./OseonHeadCollisionAnalysis");
const OseonJobsOld = () => import("./OseonJobsOld");
const SbcPendingSheetsPage = () => import("./SbcPendingSheetsPage.vue");
const DaUbicare = () => import("./DaUbicare");
const TrustoreV2 = () => import("./TrustoreV2");
const PaletteSbancalaturaV4 = () => import("./PaletteSbancalaturaV4.vue");
const Proposte = () => import("../ordini/Proposte");
const AutoPol = () => import("./AutoPol");
const TubeLaserLab = () => import("./TubeLaserLab");
import store from "../../store";
import { redirectKpi } from "./kpi/dashboard.mjs";
import { canAccessLaserKpi } from "./kpi/access.mjs";
import { canAccessTubeLaser } from "./tube-laser/tubeLaserAccess.mjs";

const ifAuthenticated = (to, from, next) => {
    if (store.getters.isLoggedIn) {
        next();
        return;
    }
    next("/login");
};

const ifAdmin = (to, from, next) => {
    if (!store.getters.isLoggedIn) {
        next("/login");
        return;
    }

    const user = store.state.user?.userdata || {};
    if (canAccessTubeLaser(user)) {
        next();
        return;
    }

    next("/");
};

export default [
    {
        path: "/laser/kpi/riepilogo/", name: "laser-kpi-riepilogo", redirect: redirectKpi,
    },
    {
        path: "/laser/nesting/:codice/",
        name: "laser-nesting-detail",
        meta: { menu: "laser", title: "Dettaglio nesting" },
        component: NestingDetail,
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/laser/prelievi-materiale/",
        name: "laser-prelievi-materiale",
        meta: {
            // Keep the existing access hierarchy while displaying Staff navigation.
            menu: "laser",
            navigationMenu: "staff",
            title: "Prelievi materiale Oseon",
            access: { defaultGroups: ["Tecnici", "Laser", "Schedulazione", "Amministrazione"] },
        },
        component: OseonMaterialWithdrawals,
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/laser/kpi/taglio/",
        redirect: redirectKpi,
    },
    {
        path: "/laser/kpi/taglio/:cuttingView(giorno|settimana|andamento|andamento-reparto)/",
        name: "laser-kpi-taglio", redirect: redirectKpi,
    },
    {
        path: "/laser/kpi/:area(ufficio-tecnico|nesting|taglio|sbancalatura|configurazione)/", redirect: redirectKpi,
    },
    {
        path: "/laser/kpi/",
        name: "laser-kpi-reparto",
        meta: { menu: "laser", title: "KPI reparto laser" },
        component: () => import("./kpi/KpiReparto.vue"),
        beforeEnter: (to, from, next) => {
            if (!store.getters.isLoggedIn) return next("/login");
            next(canAccessLaserKpi(store.getters.userdata) ? undefined : "/");
        },
    },
    {
        path: "/laser/intaglio/",
        name: "laser-intaglio",
        meta: { menu: "laser", title: "In taglio" },
        component: InTaglio,
        title: "Intaglio",
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/laser/intaglio-oseon/",
        name: "laser-intaglio-oseon",
        meta: { menu: "laser", title: "Taglio laser" },
        component: OseonJobs,
        title: "Taglio laser",
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/laser/intaglio-oseon-old/",
        name: "laser-intaglio-oseon-old",
        meta: { menu: "laser", title: "In Taglio Oseon Old" },
        component: OseonJobsOld,
        title: "In Taglio Oseon Old",
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/laser/intaglio-oseon-v2/",
        name: "laser-intaglio-oseon-v2",
        meta: { menu: "laser", title: "Laser lamiera · TEST" },
        component: OseonControlRoom,
        title: "Laser lamiera · TEST",
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/laser/intaglio-oseon-v2-classic/",
        name: "laser-intaglio-oseon-v2-classic",
        meta: { menu: "laser", title: "In Taglio TRUMPF V2 classico" },
        component: OseonJobsV2,
        title: "In Taglio TRUMPF V2 classico",
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/laser/problemi-sbancatura/",
        name: "laser-problemi-sbancatura",
        meta: { menu: "laser", title: "Nc Sbc" },
        component: OseonUnstrippedProblems,
        title: "Nc Sbc",
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/laser/analisi-fermi/",
        name: "laser-head-collision-analysis",
        meta: { menu: "laser", title: "Analisi fermi" },
        component: OseonHeadCollisionAnalysis,
        title: "Analisi fermi",
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/laser/analisi-tocchi-testa/",
        redirect: (to) => ({ path: "/laser/analisi-fermi/", query: to.query }),
    },
    {
        path: "/laser/danestare/",
        name: "laser-danestare",
        redirect: (to) => ({ name: "laser-danestare-v2", query: to.query, hash: to.hash }),
    },
    {
        path: "/laser/danestare-v2/",
        name: "laser-danestare-v2",
        meta: { menu: "laser", title: "Da Nestare" },
        component: DaNestareV2,
        title: "Da Nestare",
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/laser/programmi/",
        name: "laser-programmi",
        meta: { menu: "laser", title: "Programmi" },
        component: Programmi,
        title: "Programmi",
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/laser/sbancalatura/",
        name: "laser-sbancalatura",
        meta: {
            menu: "laser",
            title: "Fogli da sbancalare",
            access: { defaultGroups: ["Tecnici", "Laser", "Milkrun"] },
        },
        component: SbcPendingSheetsPage,
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/laser/daubicare/",
        name: "laser-daubicare",
        meta: { menu: "laser", title: "Da Ubicare" },
        component: DaUbicare,
        title: "Da Ubicare",
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/laser/trustore/",
        name: "laser-trustore",
        redirect: { name: "laser-trustore-v2" },
    },
    {
        path: "/laser/trustore-v2/",
        name: "laser-trustore-v2",
        meta: { menu: "laser", title: "Trustore" },
        component: TrustoreV2,
        title: "Trustore",
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/laser/palette-sbancalatura/",
        name: "laser-palette-sbancalatura",
        redirect: { name: "laser-sbc-v4-table-1" },
    },
    {
        path: "/laser/palette-sbancalatura-v2/",
        name: "laser-palette-sbancalatura-v2",
        redirect: { name: "laser-sbc-v4-table-1" },
    },
    {
        path: "/laser/palette-sbancalatura-v3/",
        name: "laser-palette-sbancalatura-v3",
        redirect: { name: "laser-sbc-v4-table-1" },
    },
    {
        path: "/laser/sbc-v4/",
        redirect: { name: "laser-sbc-v4-table-1" },
    },
    {
        path: "/laser/sbc-v4/tavolo-1/",
        name: "laser-sbc-v4-table-1",
        meta: { menu: "laser", title: "SBC · Tavolo 1" },
        component: PaletteSbancalaturaV4,
        props: { tableNumber: 1 },
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/laser/sbc-v4/tavolo-2/",
        name: "laser-sbc-v4-table-2",
        meta: { menu: "laser", title: "SBC · Tavolo 2" },
        component: PaletteSbancalaturaV4,
        props: { tableNumber: 2 },
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/laser/proposte/",
        name: "laser-proposte",
        meta: {
            menu: "laser", title: "Proposte",
            access: { defaultGroups: ["Amministrazione", "Schedulazione", "Tecnici", "Laser"] },
        },
        component: Proposte,
        beforeEnter: ifAuthenticated,
    },
    {
        path: "/laser/tube-laser/",
        name: "laser-tube-laser",
        meta: { menu: "tube_laser", title: "Tube Laser" },
        component: TubeLaserLab,
        beforeEnter: ifAdmin,
    },
    {
        path: "/laser/autopol/:filename?",
        name: "laser-autopol-detail",
        meta: { menu: "laser", title: "Autopol" },
        component: AutoPol,
    },
    {
        path: "/laser/autopol/",
        name: "laser-autopol",
        meta: { menu: "laser", title: "Autopol" },
        component: AutoPol,
        beforeEnter: ifAuthenticated,
    },
];
